(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-new"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── SVG icons ── */
  var ICON_CART  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><polyline points="20 6 9 17 4 12"/></svg>';
  var ICON_SPIN  = '<svg class="na-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" width="16" height="16"><path d="M12 2a10 10 0 0110 10"/></svg>';

  function setButtonState(btn, state) {
    if (!btn) return;

    btn.classList.remove('is-loading', 'is-added');
    btn.removeAttribute('aria-busy');

    if (state === 'loading') {
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      btn.innerHTML = ICON_SPIN;
      return;
    }

    if (state === 'added') {
      btn.classList.add('is-added');
      btn.innerHTML = ICON_CHECK;
      return;
    }

    btn.innerHTML = ICON_CART;
  }

  function animateNativeHorizonButton(btn) {
    if (!btn || btn.dataset.naAnimationReady === 'true') return;

    var form = btn.closest('form');
    if (!form) return;

    btn.dataset.naAnimationReady = 'true';
    btn.innerHTML = ICON_CART;

    form.addEventListener('submit', function () {
      var finished = false;
      var fallbackTimer;
      var resetTimer;

      function cleanup() {
        document.removeEventListener('cart:updated', done);
        document.removeEventListener('cart:change', done);
        document.removeEventListener('cart:update', done);
        clearTimeout(fallbackTimer);
      }

      function done() {
        if (finished) return;
        finished = true;
        cleanup();

        setButtonState(btn, 'added');
        clearTimeout(resetTimer);
        resetTimer = setTimeout(function () {
          setButtonState(btn, 'cart');
        }, 1200);
      }

      setButtonState(btn, 'loading');

      /* Horizon opens/updates the drawer natively. These listeners only control the small button animation. */
      document.addEventListener('cart:updated', done);
      document.addEventListener('cart:change', done);
      document.addEventListener('cart:update', done);

      /* Fallback in case the theme uses private events and does not dispatch the public ones. */
      fallbackTimer = setTimeout(done, 1100);
    });
  }

  function shopifyRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  }

  function cartUrl(path) {
    return shopifyRoot() + path.replace(/^\//, '');
  }

  function getCart() {
    return fetch(cartUrl('/cart.js'), {
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      return response.json();
    });
  }

  /* Replace Shopify-rendered cart sections if Shopify returns them */
  function renderCartSections(sections) {
    if (!sections) return Promise.resolve();

    Object.keys(sections).forEach(function (sectionId) {
      var html = sections[sectionId];
      if (!html) return;

      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var currentSection = document.getElementById('shopify-section-' + sectionId);
      var newSection = parsed.getElementById('shopify-section-' + sectionId) || parsed.body.firstElementChild;

      if (currentSection && newSection) {
        currentSection.replaceWith(newSection);
        return;
      }

      /* Horizon fallback: sometimes the returned HTML is the component itself, not a section wrapper */
      var horizonSelectors = [
        'cart-drawer-component',
        'cart-drawer',
        '#cart-drawer',
        '#CartDrawer',
        'cart-icon-bubble',
        '#cart-icon-bubble'
      ];

      for (var i = 0; i < horizonSelectors.length; i++) {
        var selector = horizonSelectors[i];
        var fallbackCurrent = document.querySelector(selector);
        var fallbackNew = parsed.querySelector(selector);
        if (fallbackCurrent && fallbackNew) {
          fallbackCurrent.replaceWith(fallbackNew);
          return;
        }
      }
    });

    /* Wait two frames so the drawer HTML is painted before we open it */
    return new Promise(function (resolve) {
      requestAnimationFrame(function () {
        requestAnimationFrame(resolve);
      });
    });
  }

  /* Update visible cart count/bubble without reload */
  function updateCartCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;

    var count = cart.item_count;
    var selectors = [
      '[data-cart-count]',
      '[data-item-count]',
      '.cart-count-bubble span[aria-hidden="true"]',
      '.cart-count-bubble span',
      '.cart-count-bubble',
      '#cart-icon-bubble span',
      '.header__cart .count',
      '.cart__count',
      '.CartCount',
      '.site-header__cart-count'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (!el || el.tagName === 'CART-ICON-BUBBLE') return;
        el.textContent = count;
        el.setAttribute('aria-label', count + ' items in cart');
        if (count > 0) {
          el.removeAttribute('hidden');
          el.classList.remove('hidden');
        }
      });
    });
  }

  /* Notify theme/cart listeners without opening before the HTML is ready */
  function notifyCartUpdated(cart, sections) {
    updateCartCount(cart);

    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:change',  { bubbles: true, detail: { cart: cart } }));

    /* Horizon / Shopify AI themes: update internal cart state, but do not open here */
    try {
      import('@theme/events').then(function (events) {
        if (!events || !events.CartUpdateEvent) return;

        var event = new events.CartUpdateEvent(cart, 'new-arrivals-add-to-cart', {
          itemCount: cart.item_count,
          source: 'new-arrivals-section',
          sections: sections || {}
        });

        document.dispatchEvent(event);
      }).catch(function () {});
    } catch (e) {}
  }

  function openCartAfterRender() {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        openCartFallback();
      });
    });
  }

  function openCartFallback() {
    var horizonDrawer = document.querySelector('cart-drawer-component');
    if (horizonDrawer) {
      if (typeof horizonDrawer.open === 'function') {
        horizonDrawer.open();
        return;
      }
      horizonDrawer.setAttribute('open', '');
      horizonDrawer.classList.add('is-open', 'active');
    }

    var dawnDrawer = document.querySelector('cart-drawer');
    if (dawnDrawer) {
      if (typeof dawnDrawer.open === 'function') {
        dawnDrawer.open();
        return;
      }
      dawnDrawer.setAttribute('open', '');
      dawnDrawer.classList.add('is-open', 'active', 'animate');
    }

    var toggle = document.querySelector('[aria-controls="cart-drawer"], [aria-controls="CartDrawer"], [data-drawer="cart"], .cart-drawer__toggle, #cart-icon-bubble, a[href="/cart"]');
    if (toggle && typeof toggle.click === 'function') toggle.click();
  }

  function addVariantToCart(variantId) {
    return fetch(cartUrl('/cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1
          }
        ],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          var message = data && (data.description || data.message) ? (data.description || data.message) : 'Cart error';
          throw new Error(message);
        }
        return data;
      });
    });
  }

  function initNewArrivalsSection(sec) {
    if (sec.dataset.naReady === 'true') return;
    sec.dataset.naReady = 'true';

    var layout   = sec.dataset.layout;
    var track    = sec.querySelector('.na-track');
    var viewport = sec.querySelector('.na-viewport');
    var cards    = Array.from(sec.querySelectorAll('.na-card'));
    var dotsWrap = sec.querySelector('.na-dots');
    var prevBtn  = sec.querySelector('.na-arrow--prev');
    var nextBtn  = sec.querySelector('.na-arrow--next');

    /* ── ADD TO CART ── */
    cards.forEach(function (card) {
      var btn = card.querySelector('.na-card__add');
      if (!btn || btn.disabled) return;

      /* Horizon native product-form-component handles AJAX add, cart update, and drawer opening.
         We only add button feedback animation here: spinner while adding, then check mark. */
      if (btn.closest('product-form-component')) {
        animateNativeHorizonButton(btn);
        return;
      }

      btn.innerHTML = ICON_CART;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var variantId = btn.dataset.variantId;
        if (!variantId || btn.disabled) return;

        btn.disabled = true;
        btn.innerHTML = ICON_SPIN;

        addVariantToCart(variantId)
          .then(function (addData) {
            btn.innerHTML = ICON_CHECK;

            return renderCartSections(addData.sections).then(function () {
              return getCart().then(function (cart) {
                notifyCartUpdated(cart, addData.sections || {});
                openCartAfterRender();
              });
            });
          })
          .catch(function (error) {
            console.error('Add to cart failed:', error);
            btn.innerHTML = ICON_CART;
          })
          .finally(function () {
            setTimeout(function () {
              btn.innerHTML = ICON_CART;
              btn.disabled = false;
            }, 1200);
          });
      });
    });

    /* ── GRID MODE — no carousel needed ── */
    if (layout !== 'carousel' || !track || !viewport) return;

    /* ── CAROUSEL ENGINE ── */
    var currentPage = 0;
    var totalCards  = cards.length;

    function getCols() {
      var w = window.innerWidth;
      var style = getComputedStyle(sec);
      if (w <= 749)  return parseInt(style.getPropertyValue('--na-mob-cols'))  || 2;
      if (w <= 1099) return parseInt(style.getPropertyValue('--na-tab-cols'))  || 3;
      return               parseInt(style.getPropertyValue('--na-desk-cols')) || 4;
    }

    function getRows() {
      var w = window.innerWidth;
      var style = getComputedStyle(sec);
      if (w <= 749)  return parseInt(style.getPropertyValue('--na-mob-rows'))  || 1;
      if (w <= 1099) return parseInt(style.getPropertyValue('--na-tab-rows'))  || 1;
      return               parseInt(style.getPropertyValue('--na-desk-rows')) || 1;
    }

    function getGap() {
      return parseInt(getComputedStyle(sec).getPropertyValue('--na-gap')) || 16;
    }

    function getPerPage() { return getCols() * getRows(); }
    function getTotalPages() { return Math.ceil(totalCards / getPerPage()); }

    function sizeCards() {
      var cols   = getCols();
      var gap    = getGap();
      var vpW    = viewport.clientWidth;
      var cardW  = (vpW - gap * (cols - 1)) / cols;

      cards.forEach(function (c) { c.style.width = cardW + 'px'; });

      var rows   = getRows();
      var perPg  = cols * rows;
      var pages  = Math.ceil(totalCards / perPg);

      if (rows > 1) {
        track.style.flexWrap = 'wrap';
        track.style.alignContent = 'flex-start';
        var pageW = cols * cardW + (cols - 1) * gap;
        track.style.width = (pageW * pages + gap * (pages - 1)) + 'px';
        cards.forEach(function (c, i) {
          var pg = Math.floor(i / perPg);
          c.style.marginLeft = (i % perPg === 0 && pg > 0) ? gap + 'px' : '0';
        });
      } else {
        track.style.flexWrap = 'nowrap';
        track.style.width = '';
        cards.forEach(function (c) { c.style.marginLeft = '0'; });
      }
    }

    function goTo(p, skipTransition) {
      var pages  = getTotalPages();
      currentPage = Math.max(0, Math.min(p, pages - 1));

      var cols  = getCols();
      var rows  = getRows();
      var gap   = getGap();
      var vpW   = viewport.clientWidth;
      var cardW = (vpW - gap * (cols - 1)) / cols;

      var offset;
      if (rows > 1) {
        var pageW = cols * cardW + (cols - 1) * gap;
        offset = currentPage * (pageW + gap);
      } else {
        offset = currentPage * (vpW + gap);
      }

      if (skipTransition) {
        track.style.transition = 'none';
        track.style.transform = 'translateX(-' + offset + 'px)';
        void track.offsetHeight;
        track.style.transition = '';
      } else {
        track.style.transform = 'translateX(-' + offset + 'px)';
      }

      if (prevBtn) prevBtn.disabled = currentPage === 0;
      if (nextBtn) nextBtn.disabled = currentPage >= pages - 1;

      if (dotsWrap) {
        var dots = dotsWrap.querySelectorAll('.na-dot');
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === currentPage);
          d.setAttribute('aria-selected', i === currentPage ? 'true' : 'false');
        });
      }
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var pages = getTotalPages();
      for (var i = 0; i < pages; i++) {
        var d = document.createElement('button');
        d.className = 'na-dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('role', 'tab');
        d.setAttribute('aria-label', 'Page ' + (i + 1));
        d.dataset.page = i;
        dotsWrap.appendChild(d);
      }
    }

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var b = e.target.closest('.na-dot');
        if (b) goTo(parseInt(b.dataset.page));
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentPage - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentPage + 1); });

    var touchX = 0;
    viewport.addEventListener('touchstart', function (e) { touchX = e.changedTouches[0].screenX; }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      var diff = touchX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? currentPage + 1 : currentPage - 1);
    }, { passive: true });

    sec.setAttribute('tabindex', '0');
    sec.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  goTo(currentPage - 1);
      if (e.key === 'ArrowRight') goTo(currentPage + 1);
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var savedPage = currentPage;
        sizeCards();
        buildDots();
        goTo(savedPage, true);
      }, 120);
    });

    sizeCards();
    buildDots();
    goTo(0, true);
  }

  document.querySelectorAll('.na-section').forEach(initNewArrivalsSection);

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) {
      event.target.querySelectorAll('.na-section').forEach(initNewArrivalsSection);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["na-recs-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var ICON_CART  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><polyline points="20 6 9 17 4 12"/></svg>';
  var ICON_SPIN  = '<svg class="nar-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" width="16" height="16"><path d="M12 2a10 10 0 0110 10"/></svg>';

  function shopifyRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  }

  function cartUrl(path) {
    return shopifyRoot() + path.replace(/^\//, '');
  }

  function getCart() {
    return fetch(cartUrl('/cart.js'), {
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      return response.json();
    });
  }

  function renderCartSections(sections) {
    if (!sections) return Promise.resolve();

    Object.keys(sections).forEach(function (sectionId) {
      var html = sections[sectionId];
      if (!html) return;

      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var currentSection = document.getElementById('shopify-section-' + sectionId);
      var newSection = parsed.getElementById('shopify-section-' + sectionId) || parsed.body.firstElementChild;

      if (currentSection && newSection) {
        currentSection.replaceWith(newSection);
        return;
      }

      var selectors = [
        'cart-drawer-component',
        'cart-drawer',
        '#cart-drawer',
        '#CartDrawer',
        'cart-icon-bubble',
        '#cart-icon-bubble'
      ];

      for (var i = 0; i < selectors.length; i++) {
        var current = document.querySelector(selectors[i]);
        var next = parsed.querySelector(selectors[i]);
        if (current && next) {
          current.replaceWith(next);
          return;
        }
      }
    });

    return new Promise(function (resolve) {
      requestAnimationFrame(function () {
        requestAnimationFrame(resolve);
      });
    });
  }

  function updateCartCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;

    var count = cart.item_count;
    var selectors = [
      '[data-cart-count]',
      '[data-item-count]',
      '.cart-count-bubble span[aria-hidden="true"]',
      '.cart-count-bubble span',
      '.cart-count-bubble',
      '#cart-icon-bubble span',
      '.header__cart .count',
      '.cart__count',
      '.CartCount',
      '.site-header__cart-count'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (!el || el.tagName === 'CART-ICON-BUBBLE') return;
        el.textContent = count;
        el.setAttribute('aria-label', count + ' items in cart');
        if (count > 0) {
          el.removeAttribute('hidden');
          el.classList.remove('hidden');
        }
      });
    });
  }

  function notifyCartUpdated(cart, sections) {
    updateCartCount(cart);
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:change',  { bubbles: true, detail: { cart: cart } }));

    try {
      import('@theme/events').then(function (events) {
        if (!events || !events.CartUpdateEvent) return;

        var event = new events.CartUpdateEvent(cart, 'na-recs-add-to-cart', {
          itemCount: cart.item_count,
          source: 'na-recs-section',
          sections: sections || {}
        });

        document.dispatchEvent(event);
      }).catch(function () {});
    } catch (e) {}
  }

  function openCartAfterRender() {
    requestAnimationFrame(function () {
      requestAnimationFrame(openCartFallback);
    });
  }

  function openCartFallback() {
    var horizonDrawer = document.querySelector('cart-drawer-component');
    if (horizonDrawer) {
      if (typeof horizonDrawer.open === 'function') {
        horizonDrawer.open();
        return;
      }

      horizonDrawer.setAttribute('open', '');
      horizonDrawer.classList.add('is-open', 'active');
      return;
    }

    var dawnDrawer = document.querySelector('cart-drawer');
    if (dawnDrawer) {
      if (typeof dawnDrawer.open === 'function') {
        dawnDrawer.open();
        return;
      }

      dawnDrawer.setAttribute('open', '');
      dawnDrawer.classList.add('is-open', 'active', 'animate');
      return;
    }

    var toggle = document.querySelector('[aria-controls="cart-drawer"], [aria-controls="CartDrawer"], [data-drawer="cart"], .cart-drawer__toggle, #cart-icon-bubble, a[href="/cart"]');
    if (toggle && typeof toggle.click === 'function') toggle.click();
  }

  function addVariantToCart(variantId) {
    return fetch(cartUrl('/cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1
          }
        ],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          var message = data && (data.description || data.message) ? (data.description || data.message) : 'Cart error';
          throw new Error(message);
        }

        return data;
      });
    });
  }

  function getCols(sec) {
    var w = window.innerWidth;
    var style = getComputedStyle(sec);

    if (w <= 749) return parseInt(style.getPropertyValue('--nar-mob-cols')) || 2;
    if (w <= 1099) return parseInt(style.getPropertyValue('--nar-tab-cols')) || 3;
    return parseInt(style.getPropertyValue('--nar-desk-cols')) || 4;
  }

  function getRows(sec) {
    var w = window.innerWidth;
    var style = getComputedStyle(sec);

    if (w <= 749) return parseInt(style.getPropertyValue('--nar-mob-rows')) || 1;
    if (w <= 1099) return parseInt(style.getPropertyValue('--nar-tab-rows')) || 1;
    return parseInt(style.getPropertyValue('--nar-desk-rows')) || 1;
  }

  function getGap(sec) {
    return parseInt(getComputedStyle(sec).getPropertyValue('--nar-gap')) || 16;
  }

  function setButtonState(btn, state) {
    if (!btn) return;

    btn.classList.remove('is-loading', 'is-added');
    btn.removeAttribute('aria-busy');

    if (state === 'loading') {
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      btn.innerHTML = ICON_SPIN;
      return;
    }

    if (state === 'added') {
      btn.classList.add('is-added');
      btn.innerHTML = ICON_CHECK;
      return;
    }

    btn.innerHTML = ICON_CART;
  }

  function initButtons(sec) {
    sec.querySelectorAll('.nar-card__add').forEach(function (btn) {
      if (!btn || btn.dataset.narReady === 'true') return;

      btn.dataset.narReady = 'true';
      setButtonState(btn, 'cart');

      if (btn.disabled) return;

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var variantId = btn.dataset.variantId;
        if (!variantId || btn.disabled) return;

        btn.disabled = true;
        setButtonState(btn, 'loading');

        addVariantToCart(variantId)
          .then(function (addData) {
            setButtonState(btn, 'added');

            return renderCartSections(addData.sections).then(function () {
              return getCart().then(function (cart) {
                notifyCartUpdated(cart, addData.sections || {});
                openCartAfterRender();
              });
            });
          })
          .catch(function (error) {
            console.error('Add to cart failed:', error);
            setButtonState(btn, 'cart');
          })
          .finally(function () {
            setTimeout(function () {
              btn.disabled = false;
              setButtonState(btn, 'cart');
            }, 1200);
          });
      });
    });
  }

  function initCarousel(sec) {
    if (!sec || sec.dataset.narCarouselReady === 'true') return;

    sec.dataset.narCarouselReady = 'true';

    var track = sec.querySelector('.nar-track');
    var viewport = sec.querySelector('.nar-viewport');
    var cards = Array.from(sec.querySelectorAll('.nar-card'));
    var dotsWrap = sec.querySelector('.nar-dots');
    var prevBtn = sec.querySelector('.nar-arrow--prev');
    var nextBtn = sec.querySelector('.nar-arrow--next');

    if (!track || !viewport || !cards.length) return;

    var currentPage = 0;

    function getPerPage() {
      return getCols(sec) * getRows(sec);
    }

    function getTotalPages() {
      return Math.max(1, Math.ceil(cards.length / getPerPage()));
    }

    function sizeCards() {
      var cols = getCols(sec);
      var rows = getRows(sec);
      var gap = getGap(sec);
      var vpW = viewport.clientWidth;
      var cardW = (vpW - gap * (cols - 1)) / cols;
      var perPage = cols * rows;
      var pages = Math.ceil(cards.length / perPage);

      cards.forEach(function (card) {
        card.style.width = cardW + 'px';
      });

      if (rows > 1) {
        track.style.flexWrap = 'wrap';
        track.style.alignContent = 'flex-start';
        var pageW = cols * cardW + (cols - 1) * gap;
        track.style.width = (pageW * pages + gap * (pages - 1)) + 'px';

        cards.forEach(function (card, i) {
          var pg = Math.floor(i / perPage);
          card.style.marginLeft = (i % perPage === 0 && pg > 0) ? gap + 'px' : '0';
        });
      } else {
        track.style.flexWrap = 'nowrap';
        track.style.width = '';
        cards.forEach(function (card) {
          card.style.marginLeft = '0';
        });
      }
    }

    function goTo(page, skipTransition) {
      var pages = getTotalPages();
      currentPage = Math.max(0, Math.min(page, pages - 1));

      var cols = getCols(sec);
      var rows = getRows(sec);
      var gap = getGap(sec);
      var vpW = viewport.clientWidth;
      var cardW = (vpW - gap * (cols - 1)) / cols;

      var offset;
      if (rows > 1) {
        var pageW = cols * cardW + (cols - 1) * gap;
        offset = currentPage * (pageW + gap);
      } else {
        offset = currentPage * (vpW + gap);
      }

      if (skipTransition) {
        track.style.transition = 'none';
        track.style.transform = 'translateX(-' + offset + 'px)';
        void track.offsetHeight;
        track.style.transition = '';
      } else {
        track.style.transform = 'translateX(-' + offset + 'px)';
      }

      if (prevBtn) prevBtn.disabled = currentPage === 0;
      if (nextBtn) nextBtn.disabled = currentPage >= pages - 1;

      if (dotsWrap) {
        dotsWrap.querySelectorAll('.nar-dot').forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === currentPage);
          dot.setAttribute('aria-selected', index === currentPage ? 'true' : 'false');
        });
      }
    }

    function buildDots() {
      if (!dotsWrap) return;

      dotsWrap.innerHTML = '';

      var pages = getTotalPages();
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'nar-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Page ' + (i + 1));
        dot.dataset.page = i;
        dotsWrap.appendChild(dot);
      }
    }

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (event) {
        var dot = event.target.closest('.nar-dot');
        if (dot) goTo(parseInt(dot.dataset.page));
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentPage - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentPage + 1); });

    var touchX = 0;
    viewport.addEventListener('touchstart', function (event) {
      touchX = event.changedTouches[0].screenX;
    }, { passive: true });

    viewport.addEventListener('touchend', function (event) {
      var diff = touchX - event.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? currentPage + 1 : currentPage - 1);
    }, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var savedPage = currentPage;
        sizeCards();
        buildDots();
        goTo(savedPage, true);
      }, 120);
    });

    sizeCards();
    buildDots();
    goTo(0, true);
  }

  function initNARecs(root) {
    (root || document).querySelectorAll('.nar-section').forEach(function (sec) {
      initButtons(sec);
      initCarousel(sec);
    });
  }

  function loadRecommendations(el) {
    if (!el || el.dataset.narLoaded === 'true' || !el.dataset.url) {
      initNARecs(el || document);
      return;
    }

    el.dataset.narLoaded = 'true';

    fetch(el.dataset.url)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;

        var recommendations = html.querySelector('na-product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          el.innerHTML = recommendations.innerHTML;
          initNARecs(el);
        }
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  if (!customElements.get('na-product-recommendations')) {
    customElements.define('na-product-recommendations', class NAProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('.nar-section')) {
          initNARecs(this);
          return;
        }

        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(function (entries, obs) {
            if (!entries[0].isIntersecting) return;

            obs.unobserve(entries[0].target);
            loadRecommendations(entries[0].target);
          }, { rootMargin: '0px 0px 200px 0px' });

          observer.observe(this);
        } else {
          loadRecommendations(this);
        }
      }
    });
  }

  document.querySelectorAll('na-product-recommendations').forEach(function (el) {
    if (el.querySelector('.nar-section')) {
      initNARecs(el);
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initNARecs(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
